import { FEELIX_THEMES } from '../../constants';

export const getStyleProps = (theme) => {
  const shouldUseCardStyle = [
    FEELIX_THEMES.MODERN,
    FEELIX_THEMES.PARTNER,
    FEELIX_THEMES.COMMON
  ].includes(theme);

  return (
    {
      borderRadius: 'md',
      ...(shouldUseCardStyle && {
        borderColor: 'borderDefault',
        borderWidth: 'thin',
        borderStyle: 'solid',
        borderRadius: 'xl',
        boxShadow: 'strong',
        paddingBottom: 'xl'
      })
    }
  )
};
